import { useTranslation } from 'react-i18next'

export function OverviewPlaceholder() {
  const { t } = useTranslation()
  return (
    <div className="flex h-full items-center justify-center rounded-md border border-dashed border-border/60 bg-background-app/40 text-sm text-muted">
      <div className="flex max-w-sm flex-col items-center gap-2 px-4 text-center">
        <h3 className="text-base font-medium text-foreground">
          {t('pages.calendar.overview.placeholderTitle')}
        </h3>
        <p>{t('pages.calendar.overview.placeholderBody')}</p>
      </div>
    </div>
  )
}
